import NavBar from './NavBar'
import NavBarNew from './NavBarNew'
import NavBarAgendamentoMedico from './NavBarAgendamentoMedico'
import NavBarMenuAgendamentoMedico from './NavBarMenuAgendamentoMedico'
import NavBarRemuneracaoMedicaPleno from './NavBarRemuneracaoMedicaPleno'
import NavBarRemuneracaoMedicaHospital from './NavBarRemuneracaoMedicaHospital'
import NavBarExtratoPagamento from './NavBarExtratoPagamento'

export default {
  NavBar,
  NavBarNew,
  NavBarAgendamentoMedico,
  NavBarMenuAgendamentoMedico,
  NavBarRemuneracaoMedicaPleno,
  NavBarRemuneracaoMedicaHospital,
  NavBarExtratoPagamento,
}
